<template>
    <div>
        <!-- <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
            <img class="w-full" v-for="img in state.pc_image" :src="img" />
        </div>
        <div class="mt-5 min-h-118 overflow-hidden" :style="styles">
            <div class="main-width relative pb-10">
                <div v-for="product in state.product" :key="product.product_no" :class="isVacationProduct(product.product_type) ? 'mb-3' : ''">
                    <VacationProductItem v-if="isVacationProduct(product.product_type)" :data="product" />
                    <CruiseProductItem v-else  :product="product" />
                </div> -->
                <!-- <ProductItem
                    :key="product.product_no"
                    :no="product.product_no"
                    :name="product.name"
                    :departure="product.departure"
                    :image="product.image"
                    :price="product.price"
                    :tags="product.product_tags"
                    :product-type="product.product_type"
                    :isTripartite="product.is_tripartite_product"
                    :cruiseProductType="product.cruise_product_type"
                /> -->
            <!-- </div>
        </div> -->
    </div>
</template>

<script>
import { defineComponent, useRoute, computed, useMeta } from "@nuxtjs/composition-api"
import { useAsyncState } from "@vueuse/core";
import hexRgb from 'hex-rgb';


/**************** constants ******************/
import { ERROR_OK } from "~/constants/const-http";

/**************** services ******************/
import { getTopicTemp } from "~/services/topic";

/**************** components ******************/
import CruiseProductItem from "~/components/automation/product-list-item.vue";
import VacationProductItem from "@/components/product/list-product-item-vacation.vue";
import { ProductTypes } from "~/constants/productType";

export default defineComponent({
    name: 'TopicTemp',
    components: { CruiseProductItem, VacationProductItem },
    auth: false,
    head: {},
    setup() {
        // const route = useRoute();
        
        // const { state } = useAsyncState(async () => {
        //     const { code, data, msg } = await getTopicTemp({ no: route.value.query.no })
        //     console.log(data, code, msg)
        //     if (code !== ERROR_OK) {
        //         console.error(msg)
        //         throw new Error(msg)
        //     }
 
        //     return data
        // }, {
        //     name: '',
        //     no: '',
        //     pc_image: [],
        //     h5_image: [],
        //     angle: '',
        //     gradient_end: '',
        //     gradient_start: '',
        //     poster: '',
        //     product: []
        // }, {
        //     immediate: true
        // })

        // const styles = computed(() => {
        //     const rgb = hexRgb('#C6A14A');
        //     return {
        //         '--theme-color-rgb': [rgb.red, rgb.green, rgb.blue].join(','),
        //         background: `linear-gradient(${state.value.angle}deg, ${state.value.gradient_start} 0%, ${state.value.gradient_end} 100%)`
        //     }
        // })

        // useMeta(() => ({
        //     title: state.value.name
        // }))

        // const isVacationProduct = (type) => String(type) !== ProductTypes.CRUISE
        // return {
        //     state,
        //     styles,
        //     isVacationProduct
        // }
    },
    mounted(){
        const url = `https://topic.shangchuanba.com/topic-template/${this.$route.query.no}`
        window.location = url
    }
})
</script>

<style lang="scss" scoped>

</style>
